export const en = {
    services_not_choosed: 'Nothing booked yet',
    time: 'Local time',
    timeline_title: 'Timeline',
};
